/**
 * Pixel Meta. Senza REACT_APP_META_PIXEL_ID non carica lo script e non invia eventi.
 * Pixel web dedicato (dataset Events Manager). Non è l'App ID.
 */

type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: Fbq;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

function pixelId(): string {
  return (process.env.REACT_APP_META_PIXEL_ID || "").trim();
}

/** Ogni registrazione riuscita, se il Pixel ID è configurato. La fonte non blocca l'evento. */
export function shouldTrackRegistration(): boolean {
  return pixelId().length > 0;
}

/** Parametro custom: in Events Manager si filtra signup_source = ads senza perdere le altre. */
export function registrationEventParams(signupSource: string): {
  signup_source: string;
} {
  return { signup_source: signupSource || "organic" };
}

export function initMetaPixel(): void {
  const id = pixelId();
  if (!id || typeof document === "undefined" || window.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      fbq.queue.push(args);
    }
  } as Fbq;

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  first?.parentNode?.insertBefore(script, first);

  window.fbq("init", id);
  window.fbq("track", "PageView");
}

/** Equivalente web di AppEvents.CompletedRegistration. Va chiamato prima del redirect post-signup. */
export function trackCompleteRegistration(signupSource: string): void {
  if (!shouldTrackRegistration()) return;
  initMetaPixel();
  window.fbq?.("track", "CompleteRegistration", registrationEventParams(signupSource));
}
